import { handlerArgsAtom, handlerAtom, messageAtom, openAtom } from './state';
import { confirmationStore } from './store';
import type { Handler, HandlerArgs } from './types';

export const withConfirmation = <T extends HandlerArgs, R>(
    callback: Handler<T, R>,
    msg?: string | Handler<T, string>,
) => {
    return (...args: T) => {
        confirmationStore.set(openAtom, true);

        if (msg) confirmationStore.set(messageAtom, typeof msg === 'string' ? msg : msg(...args));
        else confirmationStore.set(messageAtom, null);

        confirmationStore.set(handlerAtom, () => callback);
        confirmationStore.set(handlerArgsAtom, () => args);
    };
};
